module.exports = __webpack_public_path__ + "static/img/13.d5e3890.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/eng/13.png
// module id = yN7U
// module chunks = 0